import { customAxios } from "@/shared/lib/customAxios"
import { useQuery, type UseQueryResult } from "@tanstack/react-query"

// POST /star/info  ------------------------------ 스타 정보 조회

export interface StarInfoRequest {
  Language: string
  requestDto: {
    starId: number
  }
}

export interface StarInfoResponse {
  id: number
  name: string
  profileMessage: string
  coverImageUrl: string
  profileUrl: string
  channelUrl: string
  starUserNo: number
  starAngkorId: string
  provideName: string
  website: string
  email: string
  phone: string
  address: string
  youtubeUrl?: string
  instargramUrl?: string
  facebookUrl?: string
  angkorlifeUrl?: string
  regDt: string
}

const StarInfo = ({
  Language,
  requestDto,
}: StarInfoRequest): Promise<StarInfoResponse> => {
  return customAxios
    .post<StarInfoResponse>("star/info", requestDto, {
      headers: {
        Language: Language,
      },
    })
    .then((res) => res.data)
}

export const useStarInfoListQuery = (
  request: StarInfoRequest
): UseQueryResult<StarInfoResponse, Error> => {
  return useQuery<StarInfoResponse, Error>({
    queryKey: ["starInfo", request],
    queryFn: () => StarInfo(request),
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  })
}

// POST /star/info  ------------------------------ 스타 정보 조회
